export default function Badge({ children, className = "" }) {
    return (
        <span className={`inline-flex items-center rounded-full bg-brand-100 text-brand-700 px-2.5 py-0.5 text-xs font-medium ${className}`}>
            {children}
        </span>
    );
}
